import { useState } from 'react';
import { getConfigValue, isIos, isWeb } from '@zonofi/common';
import {
  getToken,
  useAppSelector,
  useParseFileMutation,
} from '@zonofi/seller-rtk-store';
import axios from 'axios';
import ReactNativeBlobUtil from 'react-native-blob-util';

export const useParseFile = (sellerWorkspaceId: string) => {
  const [parseFile, parseResponse] = useParseFileMutation();
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = useAppSelector(getToken);

  const onParseFileWeb = async (
    fileSource: string,
    _: string,
    onSuccess: (val: string) => void,
    onError?: () => void
  ) => {
    try {
      let data;
      const checkText = 'base64,';
      const index = fileSource.indexOf(checkText);
      if (index !== -1) {
        const mediaData = fileSource.slice(index + checkText.length);
        const byteCharacters = Buffer.from(mediaData, 'base64').toString(
          'binary'
        );
        const byteArrays = [];
        const sliceSize = 1024;
        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
        data = new Blob(byteArrays, { type: '*/*' });
      } else {
        const response = await axios.get(fileSource, {
          method: 'GET',
          responseType: 'blob',
        });
        data = response.data;
      }
      const formData = new FormData();
      formData.append('file', data);
      // parseFile({
      //   sellerWorkspaceId,
      //   body: formData,
      // })
      //   .unwrap()
      //   .then((response) => {
      //     onSuccess(response);
      //   });
    } catch (error) {
      console.error(error);
      onError && onError();
    }
  };

  const onParseFileNative = async (
    fileSource: string,
    contentType: string,
    onSuccess: (val: string) => void,
    onError?: () => void
  ) => {
    setIsLoading(true);
    const ext = contentType.split('/')[1];

    try {
      let filePath: string = '';
      if (fileSource.startsWith('http')) {
        filePath = `${ReactNativeBlobUtil.fs.dirs.CacheDir}/temp.${ext}`;
        await ReactNativeBlobUtil.config({
          fileCache: true,
          path: filePath,
        }).fetch('GET', fileSource);
      } else {
        filePath = isIos() ? fileSource.replace('file://', '') : fileSource;
      }

      const apiUrl = `${getConfigValue(
        'API_ENDPOINT'
      )}hub/bot/api/v1/parse-file?sellerWorkspaceId=${sellerWorkspaceId}`;
      const response = await ReactNativeBlobUtil.fetch(
        'POST',
        apiUrl,
        {
          Accept: '*/*',
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'multipart/form-data',
        },
        [
          {
            name: 'file',
            filename: `temp.${ext}`,
            type: contentType,
            data: isIos()
              ? ReactNativeBlobUtil.wrap(decodeURIComponent(filePath))
              : ReactNativeBlobUtil.wrap(filePath),
          },
        ]
      );

      const responseJson = await response.json();
      const parsedText = responseJson?.parsedText;
      onSuccess(parsedText);
    } catch (error) {
      onError && onError();
    }
    setIsLoading(false);
  };

  const onParseFile = isWeb() ? onParseFileWeb : onParseFileNative;
  const fileParseLoading = isWeb() ? parseResponse?.isLoading : isLoading;

  return { onParseFile, fileParseLoading };
};
